import { render, staticRenderFns } from "./WaitingItem.vue?vue&type=template&id=5570b1c2&scoped=true"
import script from "./WaitingItem.vue?vue&type=script&lang=ts"
export * from "./WaitingItem.vue?vue&type=script&lang=ts"
import style0 from "./WaitingItem.vue?vue&type=style&index=0&id=5570b1c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../Yobo/qraved-ordering-backoffice/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5570b1c2",
  null
  
)

export default component.exports